import { Action } from '@ngrx/store';
import { EncuestaSatisfaccion, EncuestaSatisfaccionProps, PreguntaSatisfaccion } from 'src/common/encuesta';

export enum PreguntaSatisfaccionActionTypes {
	PreguntasRequested = '[EncuestaSatisfaccion Component] Preguntas Requested',
	PreguntasLoaded = '[EncuestaSatisfaccion API] Preguntas Loaded',
	PreguntasCancelled = '[EncuestaSatisfaccion API] Preguntas Cancelled',
	AddEncuestaRequested = '[EncuestaSatisfaccion Component] Add Encuesta Requested',
	AddEncuestaAccepted = '[EncuestaSatifaccion API] Add Encuesta Accepted',
	AddEncuestaCancelled = '[EncuestaSatisfaccion API] Add Encuesta Cancelled',
	EncuestaPropsRequested = '[EncuestaSatisfaccion Component] Encuesta Props Requested',
	EncuestaPropsLoaded = '[EncuestaSatisfaccion API] Encuesta Props Loaded',
	EncuestaPropsCancelled = '[EncuestaSatisfaccion API] Encuesta Props Cancelled',
	EncuestaPropsAlreadyLoaded = '[EncuestaSatisfaccion API] Encuesta Props Already Loaded'
}

export class PreguntasRequested implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.PreguntasRequested;
	constructor() {
	}
}

export class PreguntasLoaded implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.PreguntasLoaded;
	constructor( public payload: PreguntaSatisfaccion[] ) {
	}
}

export class PreguntasCancelled implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.PreguntasCancelled;
	constructor() {
	}
}

export class AddEncuestaRequested implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.AddEncuestaRequested;
	constructor( public payload: EncuestaSatisfaccion ) {
	}
}

export class AddEncuestaAccepted implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.AddEncuestaAccepted;
	constructor( public payload: EncuestaSatisfaccionProps ) {
	}
}

export class AddEncuestaCancelled implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.AddEncuestaCancelled;
	constructor() {
	}
}

export class EncuestaPropsRequested implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.EncuestaPropsRequested;
	constructor() {
	}
}

export class EncuestaPropsLoaded implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.EncuestaPropsLoaded;
	constructor( public payload: EncuestaSatisfaccionProps ) {
	}
}

export class EncuestaPropsCancelled implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.EncuestaPropsCancelled;
	constructor() {
	}
}

export class EncuestaPropsAlreadyLoaded implements Action {
	readonly type: string = PreguntaSatisfaccionActionTypes.EncuestaPropsAlreadyLoaded;
	constructor() {
	}
}


export type PreguntaSatisfaccionActions = PreguntasRequested | PreguntasLoaded | PreguntasCancelled |
	AddEncuestaRequested | AddEncuestaAccepted | AddEncuestaCancelled |
	EncuestaPropsRequested | EncuestaPropsLoaded | EncuestaPropsCancelled;
